const VEHICLE_WORKFLOW_LINKS = [
  { page: "vehicle-source-review", label: "Source Review" },
  { page: "vehicle-normalization-issues", label: "Normalization Issues" },
  { page: "vehicle-duplicate-review", label: "Duplicate Review" },
  { page: "vehicle-data-quality", label: "Data Quality" },
  { page: "vehicle-fair-value", label: "Fair Value" },
  { page: "vehicle-market-analytics", label: "Market Analytics" },
];

const VehicleDataWorkflowLinks = ({ onNavigate, className = "" }) => {
  if (!onNavigate) {
    return null;
  }

  return (
    <section className={`admin-dash__card admin-vehicle-workflow-links${className ? ` ${className}` : ""}`}>
      <div className="admin-dash__card-header">
        <h2 className="admin-dash__card-title">Vehicle workflows</h2>
      </div>
      <p className="muted admin-dashboard__subtitle">
        Source inventory and health are in the unified grid above. Open compliance review,
        ingestion runs, fair value, and other vehicle workflows below.
      </p>
      <div className="admin-vehicle-workflow-links__actions">
        {VEHICLE_WORKFLOW_LINKS.map((link) => (
          <button
            key={link.page}
            type="button"
            className="admin-dashboard__action-btn"
            onClick={() => onNavigate(link.page)}
          >
            {link.label}
          </button>
        ))}
      </div>
    </section>
  );
};

export default VehicleDataWorkflowLinks;
